import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgBulb = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M12 0c.663 0 1.2.533 1.2 1.19v1.19c0 .657-.537 1.19-1.2 1.19-.663 0-1.2-.533-1.2-1.19V1.19C10.8.533 11.337 0 12 0ZM3.471 3.443a1.207 1.207 0 0 1 1.698 0l.84.833a1.183 1.183 0 0 1 0 1.683 1.207 1.207 0 0 1-1.698 0l-.84-.833a1.183 1.183 0 0 1 0-1.683Zm17.058 0a1.183 1.183 0 0 1 0 1.683l-.84.833a1.207 1.207 0 0 1-1.698 0 1.183 1.183 0 0 1 0-1.683l.84-.833a1.207 1.207 0 0 1 1.698 0ZM0 11.9c0-.657.537-1.19 1.2-1.19h1.2c.663 0 1.2.533 1.2 1.19 0 .657-.537 1.19-1.2 1.19H1.2c-.663 0-1.2-.533-1.2-1.19Zm20.4 0c0-.657.537-1.19 1.2-1.19h1.2c.663 0 1.2.533 1.2 1.19 0 .657-.537 1.19-1.2 1.19h-1.2c-.663 0-1.2-.533-1.2-1.19ZM12 7.14c-1.007 0-1.99.315-2.807.9a4.763 4.763 0 0 0-1.747 2.356 4.723 4.723 0 0 0-.028 2.924c.3.954.896 1.79 1.702 2.39.044.032.085.067.124.105a5.348 5.348 0 0 1 1.324 2.113c.257.763.337 1.574.234 2.37.017.292.14.568.35.775a1.205 1.205 0 0 0 1.697 0c.209-.207.332-.483.35-.774a5.312 5.312 0 0 1 .233-2.371 5.348 5.348 0 0 1 1.324-2.113 1.26 1.26 0 0 1 .124-.106 4.762 4.762 0 0 0 1.702-2.389 4.73 4.73 0 0 0-.028-2.925 4.763 4.763 0 0 0-1.747-2.356A4.827 4.827 0 0 0 12 7.141ZM7.79 6.109A7.24 7.24 0 0 1 12 4.76a7.24 7.24 0 0 1 4.21 1.348 7.145 7.145 0 0 1 2.62 3.535 7.085 7.085 0 0 1 .043 4.387 7.14 7.14 0 0 1-2.479 3.528 2.952 2.952 0 0 0-.807 2.5c.009.057.013.115.013.174 0 .946-.38 1.855-1.054 2.524A3.615 3.615 0 0 1 12 23.802c-.955 0-1.87-.376-2.546-1.046A3.555 3.555 0 0 1 8.4 20.232c0-.059.004-.117.013-.175a2.952 2.952 0 0 0-.807-2.5 7.14 7.14 0 0 1-2.478-3.527 7.084 7.084 0 0 1 .042-4.387 7.145 7.145 0 0 1 2.62-3.535Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M8.04 17.851c0-.657.537-1.19 1.2-1.19h5.52c.663 0 1.2.533 1.2 1.19 0 .658-.537 1.19-1.2 1.19H9.24c-.663 0-1.2-.532-1.2-1.19Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgBulb);
export default ForwardRef;
